/**
 * Check if a value is a DOM node.
 */

function isDOMNode(value) {
  return Boolean(window) && value instanceof window.Node;
}

export { isDOMNode };
